import fonts from '../../styles/fonts';
import palette from '../../styles/palette';
import position from '../../styles/position';

const styles = {
    wrapper: position.absoluteFill,
    title: {
        ...fonts.title,
        fontSize: 40,
        color: palette.text.primary,
    } as React.CSSProperties,
    message: {
        ...fonts.subTitle,
        fontSize: 20,
        color: palette.text.secondary,
    } as React.CSSProperties,
    card: {
        margin: 10
    } as React.CSSProperties,
    barcodeCard: {
        border: "solid 1px #eee",
        padding: 20,
        margin: 5,
        borderRadius: 5,
        height: "100%",
        maxHeight: 200,
        maxWidth: 180,
        flex: "1 1 100%"
    },
    barcodeTitle: {
        marginBottom: 20
    },
    barcodeCardText: {
        marginBottom: 20,
        fontSize: 12,
        height: 50
    },
    product_catalogue_subheading: {
        fontWeight: 'bold',
        fontSize: 16,
        margin: 0,
    } as React.CSSProperties
};
export default styles;